import cx from 'classnames';
import { Card } from 'react-bootstrap';

const Tile = ({ tile, selected, onClick }) => {
  const { name, thumbnail } = tile;
  const handleClick = () => onClick(tile);

  return (
    <Card className={cx('tile', selected ? 'tile--selected' : '')} onClick={handleClick}>
      <img className="tile-image" src={thumbnail} alt={name} />
      <Card.Body className="tile-body">
        <Card.Text className="tile-text" as="span">
          {name}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default Tile;
